import { c as _c } from "react/compiler-runtime";
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReCAPTCHA from 'react-google-recaptcha';
import loadable from '@loadable/component';
import validateEmail from 'commons/validateEmail';
import capitalizeFirstLetter from 'commons/capitalizeFirstLetter';
import BriteverifyClient from 'commons/britverify-client';
import isLocalhost from 'commons/isLocalhost';
import { INVALID_NAME_CHARACTERS_REGEX, RECAPTCHA_SITE_KEY } from 'commons/constants';
import WarrantyForm from 'components/consumer/WarrantyForm';
import CtaButton from 'components/essentials/Cta/CtaButton';
import FrameContainer from 'components/consumer/FrameContainer';
import LabeledTextarea from 'components/consumer/LabeledTextarea';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import FlatButtonFilters from 'components/consumer/FlatButtonFilters';
import Radio from 'components/essentials/Radio';
import IconAskAQuestion from 'components/icons/IconAskAQuestion';
import { colorBrandLightest } from 'styles/layout/colors';
import FrameContainerHeader from 'components/consumer/FrameContainerHeader';
import useUserData from 'data-hooks/useUserData';
import questionsAndAnswers from './questionsAndAnswers.json';
import CtaLink from '../../essentials/Cta/CtaLink';
const AnimateHeight = loadable(() => import('react-animate-height'));
const ContactEnquiryFormUI = t0 => {
  const $ = _c(81);
  const {
    error,
    loading,
    onSubmit
  } = t0;
  const {
    email: userEmail,
    firstName
  } = useUserData();
  const t1 = firstName || "";
  let t2;
  if ($[0] !== t1) {
    t2 = capitalizeFirstLetter(t1.toLowerCase());
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [name, setName] = useState(t2);
  const t3 = userEmail || "";
  let t4;
  if ($[2] !== t3) {
    t4 = t3.toLowerCase();
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [email, setEmail] = useState(t4);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState("");
  const [selectedTag, setSelectedTag] = useState("");
  const [message, setMessage] = useState("");
  const [reCaptchaValue, setReCaptchaValue] = useState("");
  const [isNameValid, setIsNameValid] = useState(true);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isSelectedTopicValid, setIsSelectedTopicValid] = useState(true);
  const [isMessageValid, setIsMessageValid] = useState(true);
  const [isReCaptchaValid, setIsReCaptchaValid] = useState(true);
  const _isNameValid = !!name;
  let t5;
  if ($[4] !== email) {
    t5 = !!email && validateEmail(email);
    $[4] = email;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const _isEmailValid = t5;
  const _isSelectedTopicValid = !!selectedTopic;
  const _isMessageValid = !!message;
  const _isSelectedQuestionValid = !!selectedQuestion;
  let t6;
  if ($[6] !== reCaptchaValue) {
    t6 = !isLocalhost() ? !!reCaptchaValue : true;
    $[6] = reCaptchaValue;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const _isReCaptchaValid = t6;
  const isOptionSelected = _isSelectedTopicValid && _isSelectedQuestionValid;
  const isSubmitValid = _isNameValid && _isEmailValid && _isSelectedTopicValid && _isSelectedQuestionValid && _isMessageValid && _isReCaptchaValid;
  let t7;
  if ($[8] !== _isEmailValid || $[9] !== _isMessageValid || $[10] !== _isNameValid || $[11] !== _isReCaptchaValid || $[12] !== _isSelectedTopicValid || $[13] !== email || $[14] !== isSubmitValid || $[15] !== message || $[16] !== name || $[17] !== onSubmit || $[18] !== reCaptchaValue || $[19] !== selectedQuestion || $[20] !== selectedTag || $[21] !== selectedTopic) {
    t7 = () => {
      if (isSubmitValid) {
        onSubmit({
          name,
          email: email.trim(),
          subject: selectedTopic,
          question: selectedQuestion || "Other",
          tag: selectedTag,
          message,
          subscribe: false,
          phone: "",
          reCaptchaValue
        });
      }
      setIsNameValid(_isNameValid);
      setIsEmailValid(_isEmailValid);
      setIsSelectedTopicValid(_isSelectedTopicValid);
      setIsMessageValid(_isMessageValid);
      setIsReCaptchaValid(_isReCaptchaValid);
    };
    $[8] = _isEmailValid;
    $[9] = _isMessageValid;
    $[10] = _isNameValid;
    $[11] = _isReCaptchaValid;
    $[12] = _isSelectedTopicValid;
    $[13] = email;
    $[14] = isSubmitValid;
    $[15] = message;
    $[16] = name;
    $[17] = onSubmit;
    $[18] = reCaptchaValue;
    $[19] = selectedQuestion;
    $[20] = selectedTag;
    $[21] = selectedTopic;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const validateAndSubmit = t7;
  let t8;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FrameContainerHeader icon={<IconAskAQuestion color={colorBrandLightest} />} title="Ask us a question" subtitle={"Contact one of our experts and we\u2019ll get back to you as soon as possible."} />;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t10;
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e => {
      setIsNameValid(true);
      setName(e.target.value);
    };
    t10 = evt => {
      if (INVALID_NAME_CHARACTERS_REGEX.test(evt.target.value)) {
        setIsNameValid(false);
      } else {
        setIsNameValid(true);
      }
    };
    $[24] = t10;
    $[25] = t9;
  } else {
    t10 = $[24];
    t9 = $[25];
  }
  const t11 = !isNameValid ? "Please enter valid characters only." : undefined;
  let t12;
  if ($[26] !== name || $[27] !== t11) {
    t12 = <LabeledTextInput label="Your name" value={name} onChange={t9} onBlur={t10} errorMessage={t11} />;
    $[26] = name;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e_0 => {
      setIsEmailValid(true);
      setEmail(e_0.target.value);
    };
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== email) {
    t14 = async evt_0 => {
      const updatedEmail = evt_0.target.value.trim();
      if (email !== updatedEmail) {
        setEmail(updatedEmail);
      }
      const validate = await BriteverifyClient.emailLookup(updatedEmail);
      if (!validate?.valid && validate?.message) {
        setIsEmailValid(false);
      } else {
        setIsEmailValid(true);
      }
    };
    $[30] = email;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const t15 = !isEmailValid ? "Please enter a valid email address." : undefined;
  let t16;
  if ($[32] !== email || $[33] !== t14 || $[34] !== t15) {
    t16 = <LabeledTextInput label="Email address" value={email} onChange={t13} onBlur={t14} errorMessage={t15} />;
    $[32] = email;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="text-lg font-bold mb-3">What can we help you with today?</div>;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = questionsAndAnswers.map(_temp);
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== selectedTopic) {
    t19 = topicId => {
      setIsSelectedTopicValid(true);
      if (topicId !== selectedTopic) {
        setSelectedTag("");
        setSelectedQuestion("");
        setSelectedTopic(topicId);
      }
    };
    $[38] = selectedTopic;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== selectedTopic || $[41] !== t19) {
    t20 = <FlatButtonFilters items={t18} isSelectedButtonFilled={true} selectedItem={selectedTopic} setSelectedItem={t19} />;
    $[40] = selectedTopic;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== isSelectedTopicValid) {
    t21 = !isSelectedTopicValid && <div className="text-red text-xs font-bold mt-[3px]">Please select an option.</div>;
    $[43] = isSelectedTopicValid;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t20 || $[46] !== t21) {
    t22 = <div className="mt-8 mx-0 mb-10">{t17}{t20}{t21}</div>;
    $[45] = t20;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== selectedQuestion || $[49] !== selectedTopic || $[50] !== userEmail) {
    t23 = !!selectedTopic && !!questionsAndAnswers.find(topic_1 => topic_1.topicId === selectedTopic) && <div className="mt-8 mx-0 mb-10 [border-top:1px_solid_#f1f1f1] pt-8"><div className="text-lg font-bold mb-3">We can help! What's your question?</div><div>{questionsAndAnswers.find(topic_0 => topic_0.topicId === selectedTopic).questions.map((t24, questionIndex) => {
          const {
            question,
            answer,
            tag,
            warrantyFooter,
            warrantyForm: t25
          } = t24;
          const warrantyForm = t25 === undefined ? false : t25;
          return <><Radio key={`${selectedTopic}-${questionIndex}`} onChange={() => {
              setSelectedTag(tag);
              setSelectedQuestion(question);
            }} checked={selectedQuestion === question}><span className={classNames("text-base", {
                "text-base font-bold": selectedQuestion === question
              })}>{question}</span></Radio>{(answer.length > 0 || warrantyForm || warrantyFooter) && <AnimateHeight duration={500} height={selectedQuestion === question && question !== "Other" ? "auto" : 0}><div className="bg-gray-light8 rounded mt-2 mx-0 mb-4 p-8 [&_p]:text-base [&_p_a]:ml-1 [&_p+p]:mt-5">{answer.map(_temp2)}{warrantyForm && <WarrantyForm email={userEmail || null} redirectToStep2={true} variant="ContactEnquiryForm" />}{warrantyFooter && <p className="ContactEnquiryFormUI__question-warrantyFooter">If you’d like to submit a warranty request, please see our<CtaLink to="/issues/" color="brand" target="_blank" hasArrow={false}>warranty form.</CtaLink></p>}</div></AnimateHeight>}</>;
        })}</div></div>;
    $[48] = selectedQuestion;
    $[49] = selectedTopic;
    $[50] = userEmail;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = e_1 => {
      setIsMessageValid(true);
      setMessage(e_1.target.value);
    };
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  const t25 = !isMessageValid ? "Please tell us more about what we can help you with." : undefined;
  let t26;
  if ($[53] !== message || $[54] !== t25) {
    t26 = <LabeledTextarea label="Your Message. Please include order number where applicable." value={message} onChange={t24} errorMessage={t25} />;
    $[53] = message;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <ReCAPTCHA name="reCaptchaValue" sitekey={RECAPTCHA_SITE_KEY} onChange={value => {
      setReCaptchaValue(value);
      if (value) {
        setIsReCaptchaValid(true);
      }
    }} />;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== isReCaptchaValid) {
    t28 = !isReCaptchaValid && <div className="text-red text-xs font-bold mt-[3px]">Please confirm that you are not a robot</div>;
    $[57] = isReCaptchaValid;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t28) {
    t29 = <div className="mb-8">{t27}{t28}</div>;
    $[59] = t28;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  const t30 = !isSubmitValid || loading;
  let t31;
  if ($[61] !== loading || $[62] !== t30 || $[63] !== validateAndSubmit) {
    t31 = <CtaButton block={true} spacing="xs" disabled={t30} onClick={validateAndSubmit} isLoading={loading}>Send your question</CtaButton>;
    $[61] = loading;
    $[62] = t30;
    $[63] = validateAndSubmit;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] !== error) {
    t32 = error && <div className="text-red text-xs font-bold mt-[3px]">{error}</div>;
    $[65] = error;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== isOptionSelected) {
    t33 = !isOptionSelected && <div className="text-xs font-bold mt-[3px] text-gray text-center">Please select an option above</div>;
    $[67] = isOptionSelected;
    $[68] = t33;
  } else {
    t33 = $[68];
  }
  let t34;
  if ($[69] !== t31 || $[70] !== t32 || $[71] !== t33) {
    t34 = <div className="ContactEnquiryFormUI__submit-section">{t31}{t32}{t33}</div>;
    $[69] = t31;
    $[70] = t32;
    $[71] = t33;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] !== t12 || $[74] !== t16 || $[75] !== t22 || $[76] !== t23 || $[77] !== t26 || $[78] !== t29 || $[79] !== t34) {
    t35 = <FrameContainer wide={true} className="max-[767px]:!pb-8 md:!rounded-none">{t8}{t12}{t16}{t22}{t23}{t26}{t29}{t34}</FrameContainer>;
    $[73] = t12;
    $[74] = t16;
    $[75] = t22;
    $[76] = t23;
    $[77] = t26;
    $[78] = t29;
    $[79] = t34;
    $[80] = t35;
  } else {
    t35 = $[80];
  }
  return t35;
};
ContactEnquiryFormUI.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  onSubmit: PropTypes.func.isRequired
};
export default ContactEnquiryFormUI;
function _temp(topic) {
  return {
    label: topic.topicLabel,
    id: topic.topicId
  };
}
function _temp2(answerParagraph) {
  return <p className="[&_a]:text-brand [&_a]:underline" dangerouslySetInnerHTML={{
    __html: answerParagraph
  }} />;
}